module.exports = __webpack_public_path__ + "img/vking 로고.67e225ce.png";